// Written in this round about way for babel-transform-imports
import Redirect from "react-router/es/Redirect";

export default Redirect;


//////////////////
// WEBPACK FOOTER
// /~/react-router-dom/es/Redirect.js
// module id = PGPo
// module chunks = 0